import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container grid w-full max-w-[1192px] gap-3 md:grid-cols-[auto_auto] md:gap-20',
    title: 'heading-xl md:heading-2xl flex w-full max-w-[262px] md:justify-end',
    content: 'heading-s md:heading-m leading-[1.7]',
    collapseButton: 'heading-s-bold mt-2 px-0 tracking-wider md:mt-6',
    arrow: 'm-1 transition-transform'
  }
});
